/**
 * Payload's default handler uses credentials: 'include' and initialData.id for the URL.
 * Omit credentials so public read works with dev CORS.
 *
 * @param {import('@payloadcms/live-preview').CollectionPopulationRequestHandlerArgs} args
 */
export async function promotionsLivePreviewRequestHandler({
  apiPath,
  data,
  serverURL,
}) {
  const incoming = data?.data;
  const docId = incoming?.id;

  if (!docId) {
    return new Response(JSON.stringify(incoming ?? {}), {
      status: 200,
      headers: { "Content-Type": "application/json" },
    });
  }

  const url = `${serverURL}${apiPath}/promotions/${docId}`;
  return fetch(url, {
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      "X-Payload-HTTP-Method-Override": "GET",
    },
    method: "POST",
  });
}
